import React from 'react';
import InternetExplorer from '../InternetExplorer';

function DSAInternetExplorer(props) {
    return <InternetExplorer {...props} startUrl="https://deadsimpleaccounting.co.uk" />;
}

export default DSAInternetExplorer;
